import $ from "jquery";
import _ from "underscore";
import Backbone from "backbone";

const ajaxRequestWithTokenRefresh = ({ onError = () => {}, ...args }) =>
  $.ajax({
    retryLimit: 3,
    error: function (error) {
      if (error.status === 401) {
        $.post(
          Base.get_route(["base", "user_token"]),
          {
            csrfmiddlewaretoken: csrf_token,
          },
          (response) => {
            if (response.status === 200 && response.data.id_token) {
              S.session.token = response.data.id_token;
              S.session.access_token = response.data.access_token;

              this.retryLimit--;
              if (this.retryLimit) {
                $.ajax({
                  ...this,
                  headers: { "User-Info": S.session.token },
                });
                return;
              } else {
                onError();
              }
            } else {
              // The user has no valid auth session, redirect to logout
              document.location.href =
                response.logout_url ||
                `${S.session.auth_url}openid/end-session`;
            }
          }
        );
      }
    },
    ...args,
  });

class HeaderMessages extends Backbone.Model {
  get defaults() {
    return {
      unreadCount: 0,
      loading: true,
      error: false,
      conversations: false,
      showDropdown: false,
    };
  }

  initialize() {
    this.view = new HeaderMessagesView({
      model: this,
    });

    this.listenTo(this, "change:showDropdown", () => {
      if (this.get("showDropdown") && this.get("conversations") === false) {
        this.loadConversations();
      }
    });

    if (!S.session.disabled_unread_count) {
      this.fetchUnreadMessagesCount();
    }
  }

  fetchUnreadMessagesCount() {
    ajaxRequestWithTokenRefresh({
      url: S.session.messages_url + current_user_id + "/unread_count",
      data: {},
      headers: {
        "User-Info": S.session.token,
      },
      type: "GET",
      success: (response, textStatus) => {
        if (textStatus === "success") {
          this.set("unreadCount", response.unread_message_count);

          // Update any other elements interesting in this...
          // (The module box on base/overview.html)
          $(".unread-messages-counter").text(
            response.unread_message_count || ""
          );
        } else {
          AlertBar.showErrorMessage(response.error);
        }
      },
    });
  }

  loadConversations() {
    ajaxRequestWithTokenRefresh({
      url: S.session.messages_url + current_user_id + "/conversations",
      data: {
        per_page: 5,
      },
      headers: {
        "User-Info": S.session.token,
      },
      type: "GET",
      success: (response, textStatus) => {
        if (textStatus === "success" && response.conversations) {
          this.set({
            loading: false,
            conversations: response.conversations,
          });
        } else {
          AlertBar.showErrorMessage(response.error);
        }
      },
      onError: () => {
        this.set({
          error: true,
          loading: false,
          conversations: false,
        });
      },
    });
  }

  addConversation(conversationData) {
    if (this.get("conversations")) {
      this.get("conversations").unshift(conversationData);
      this.view.render();
    }
  }
}

class HeaderMessagesView extends Backbone.View {
  get el() {
    return "#header-messages";
  }

  set el(_) {}

  get template() {
    return _.template($("#header-messages-template").html());
  }

  initialize() {
    this.$count = this.$("#iconbar-unread-count");

    this.render();
    this.listenTo(this.model, "change", this.render.bind(this));
  }

  get events() {
    return {
      "click .btn-show-messages": "toggleMessageDropdown",
      "click .messages-tooltip-overlay": "toggleMessageDropdown",
    };
  }

  toggleMessageDropdown() {
    this.model.set("showDropdown", !this.model.get("showDropdown"));
  }

  render() {
    const unreadCount = this.model.get("unreadCount");
    this.$count.toggleClass("hide", !unreadCount);
    this.$el.html(this.template(this.model.attributes));

    this.$('[data-toggle="message-dialog"]').enableMessageLink();
  }
}

export default HeaderMessages;
